export default __webpack_public_path__ + "static/media/img_blanketBase_beige.ee61354e.jpg";